module.exports = __webpack_public_path__ + "static/img/rule.0ca57f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/springFestivalActive/light/rule.png
// module id = Mrhb
// module chunks = 1